import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { DollarSign, Loader2 } from "lucide-react";
import POSHeader from "./POSHeader";

export default function AbrirCaixaView({ authAxios, onBack, onCaixaAberto }) {
  const [valorInicial, setValorInicial] = useState("");
  const [processing, setProcessing] = useState(false);

  const handleAbrirCaixa = async () => {
    setProcessing(true);
    try {
      const valor = parseFloat(valorInicial) || 0;
      await authAxios.post("/pos/caixa/abrir", { valor_inicial: valor });
      toast.success(`Caixa aberto com €${valor.toFixed(2)}`);
      onCaixaAberto(true);
      onBack();
    } catch (err) {
      const detail = err?.response?.data?.detail || "";
      if (detail.toLowerCase().includes("já está aberto") || detail.toLowerCase().includes("ya está abierto")) {
        toast.info("Caixa já está aberto — continuando.");
        onCaixaAberto(true);
        onBack();
      } else {
        toast.error(detail || "Erro ao abrir caixa");
      }
    }
    setProcessing(false);
  };

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col" data-testid="pos-abrir-caixa">
      <POSHeader title="Abrir Caixa" icon={DollarSign} onBack={onBack} />
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-sm">
          <div className="text-center mb-6">
            <DollarSign className="w-16 h-16 mx-auto text-emerald-600 mb-2" />
            <h2 className="text-xl font-bold text-gray-800">Valor Inicial do Caixa</h2>
            <p className="text-sm text-gray-500">Informe o valor em dinheiro no caixa</p>
          </div>
          <Input
            type="number"
            step="0.01"
            placeholder="0.00"
            value={valorInicial}
            onChange={(e) => setValorInicial(e.target.value)}
            className="h-16 text-3xl font-bold text-center mb-4"
            autoFocus
          />
          <div className="grid grid-cols-4 gap-2 mb-4">
            {[0, 50, 100, 200].map(v => (
              <Button key={v} variant="outline" className="h-12 font-bold" onClick={() => setValorInicial(String(v))}>
                €{v}
              </Button>
            ))}
          </div>
          <Button
            className="w-full h-14 bg-emerald-600 hover:bg-emerald-700 font-bold text-lg"
            onClick={handleAbrirCaixa}
            disabled={processing}
          >
            {processing ? <Loader2 className="w-5 h-5 animate-spin" /> : "ABRIR CAIXA"}
          </Button>
        </div>
      </div>
    </div>
  );
}
